import { graphql, useStaticQuery } from "gatsby";

const NewsCategories = () => {
    const resourceData = useStaticQuery(graphql`
        query allNewsCategoryData {
            allCategoryData: allContentfulNews(sort: [{ dateTime: DESC }, { updatedAt: DESC }]) {
                By_Year: group(field: { dateTime: SELECT }) {
                    fieldValue
                    edges {
                        node {
                            id
                            newsType {
                                id
                                name
                                title
                            }
                        }
                    }
                }
                By_Industry: group(field: { industry: { title: SELECT } }) {
                    fieldValue
                    edges {
                        node {
                            id
                        }
                    }
                }
            }
        }
    `);

    return resourceData;
};

export default NewsCategories;
